import React from "react";
import ReactDOM from "react-dom/client";
import { loadRuntimeConfig } from "./lib/runtime-config";
import "./index.css";

function showConfigError(message: string) {
  const root = document.getElementById("root");
  if (!root) {
    return;
  }
  const paragraph = document.createElement("p");
  paragraph.textContent = message;
  root.replaceChildren(paragraph);
}

async function bootstrap() {
  try {
    await loadRuntimeConfig();
  } catch (error) {
    console.error(error);
    showConfigError(
      "Failed to load application configuration. Check that /env.json is served and valid."
    );
    return;
  }

  const { default: App } = await import("./App");
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

void bootstrap();
